import { Pipe, PipeTransform } from '@angular/core';
import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'typeOfUser',
  standalone: false,
})
export class TypeOfUserPipe implements PipeTransform {

  constructor(private translate: TranslateService) { }

  transform(value: number): any {
    let type: string = '';

    switch (value) {
      case AppConst.MANAGE_USER_TYPE_USER:
        type = this.translate.instant('一般ユーザー');
        break;
      case AppConst.MANAGE_USER_TYPE_MASTER:
        type = this.translate.instant('プロジェクト管理ユーザ');
        break;
      case AppConst.MANAGE_USER_TYPE_ADMIN:
        type = this.translate.instant('アドミンユーザー');
        break;
    }
    return type;
  }

}
